const PROFILE_ROUTES = Object.freeze({
	profile: {
		name: 'PorfileRoot',
		path: '/profile',
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/modules/profile/views/RootView.vue'),
	},
	profileShop: {
		name: 'ProfileShopId',
		path: ':shopId',
		meta: {
			layout: 'Simple',
			requiresBusinessInfo: true,
		},
		component: () => import('@/presentation/modules/profile/views/shop-view/ShopView.vue'),
	},
	profilePost: {
		name: 'ProfilePostId',
		path: ':shopId/post/:postId',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/profile/views/PostView.vue'),
	},
	profileEditPost: {
		name: 'ProfileEditPostId',
		path: ':shopId/post/:postId/edit',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/profile/views/CreatePostView.vue'),
	},
	profileSetting: {
		name: 'ProfileSetting',
		path: 'setting',
		component: () => import('@/presentation/modules/profile/views/SettingView.vue'),
		meta: {
			layout: 'Simple',
			requiresBusinessInfo: true,
		},
	},
	profileCreatePost: {
		name: 'ProfileCreatePost',
		path: 'create-post',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/profile/views/CreatePostView.vue'),
	},
	profileArtist: {
		name: 'ProfileArtist',
		path: ':shopId/services/artists',
		meta: {
			layout: 'Simple',
			blockedRoles: ['Business'],
		},
		component: () => import('@/presentation/modules/profile/views/ArtistView.vue'),
	},
	profileService: {
		name: 'ProfileService',
		path: ':shopId/services',
		alias: ':shopId/reserve',
		meta: {
			layout: 'Simple',
			blockedRoles: ['Business'],
		},
		component: () => import('@/presentation/modules/profile/views/ServiceView.vue'),
	},
	profileChooseTime: {
		name: 'ProfileChooseTime',
		path: ':shopId/services/artists/choose-time',
		meta: {
			layout: 'Simple',
			blockedRoles: ['Business'],
		},
		component: () => import('@/presentation/modules/profile/views/ChooseTimeView.vue'),
	},
	profileReservationSummary: {
		name: 'ProfileReservationSummary',
		path: ':shopId/services/summary',
		meta: {
			layout: 'Simple',
			blockedRoles: ['Business'],
			noindex: true,
		},
		component: () => import('@/presentation/modules/profile/views/ReservationGuestView.vue'),
	},
});

export default PROFILE_ROUTES;
